const _excluded = ["active", "as", "children", "className", "icon", "label", "labelColor", "theme"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { forwardRef, useId } from 'react';
import { Badge, Tooltip, useTheme } from '../../';
import { mergeDeep } from '../../helpers/merge-deep';
import { useSidebarContext } from './SidebarContext';
import { useSidebarItemContext } from './SidebarItemContext';
const ListItem = _ref => {
  let id = _ref.id,
    isCollapsed = _ref.isCollapsed,
    tooltipChildren = _ref.tooltipChildren,
    wrapperChildren = _ref.children;
  return _jsx("li", {
    children: isCollapsed ? _jsx(Tooltip, {
      content: _jsx(TooltipContent, {
        id: id,
        children: tooltipChildren
      }),
      placement: "right",
      children: wrapperChildren
    }) : wrapperChildren
  });
};
const TooltipContent = _ref2 => {
  let id = _ref2.id,
    children = _ref2.children;
  return _jsx(Children, {
    id: id,
    children: children
  });
};
const Children = _ref3 => {
  let id = _ref3.id,
    children = _ref3.children;
  const theme = useTheme().theme.sidebar.item;
  return _jsx("span", {
    "data-testid": "flowbite-sidebar-item-content",
    id: `flowbite-sidebar-item-${id}`,
    className: classNames(theme.content.base),
    children: children
  });
};
export const SidebarItem = /*#__PURE__*/forwardRef((_ref4, ref) => {
  var _theme$collapsed, _theme$icon, _theme$icon2, _theme$collapsed2, _children$charAt$toLo;
  let isActive = _ref4.active,
    _ref4$as = _ref4.as,
    Component = _ref4$as === void 0 ? 'a' : _ref4$as,
    children = _ref4.children,
    className = _ref4.className,
    Icon = _ref4.icon,
    label = _ref4.label,
    _ref4$labelColor = _ref4.labelColor,
    labelColor = _ref4$labelColor === void 0 ? 'info' : _ref4$labelColor,
    _ref4$theme = _ref4.theme,
    customTheme = _ref4$theme === void 0 ? {} : _ref4$theme,
    props = _objectWithoutProperties(_ref4, _excluded);
  const id = useId();
  const _useSidebarContext = useSidebarContext(),
    isCollapsed = _useSidebarContext.isCollapsed;
  const _useSidebarItemContex = useSidebarItemContext(),
    isInsideCollapse = _useSidebarItemContex.isInsideCollapse;
  const theme = mergeDeep(useTheme().theme.sidebar.item, customTheme);
  return _jsx(ListItem, {
    id: id,
    isCollapsed: isCollapsed,
    tooltipChildren: children,
    children: _jsxs(Component, _objectSpread(_objectSpread({
      "aria-labelledby": `flowbite-sidebar-item-${id}`,
      ref: ref,
      className: classNames(theme.base, isActive && theme.active, !isCollapsed && isInsideCollapse && ((_theme$collapsed = theme.collapsed) === null || _theme$collapsed === void 0 ? void 0 : _theme$collapsed.insideCollapse), className)
    }, props), {}, {
      children: [Icon && _jsx(Icon, {
        "aria-hidden": true,
        "data-testid": "flowbite-sidebar-item-icon",
        className: classNames((_theme$icon = theme.icon) === null || _theme$icon === void 0 ? void 0 : _theme$icon.base, isActive && ((_theme$icon2 = theme.icon) === null || _theme$icon2 === void 0 ? void 0 : _theme$icon2.active))
      }), isCollapsed && !Icon && _jsx("span", {
        className: (_theme$collapsed2 = theme.collapsed) === null || _theme$collapsed2 === void 0 ? void 0 : _theme$collapsed2.noIcon,
        children: (_children$charAt$toLo = children.charAt(0).toLocaleUpperCase()) !== null && _children$charAt$toLo !== void 0 ? _children$charAt$toLo : '?'
      }), !isCollapsed && _jsx(Children, {
        id: id,
        children: children
      }), !isCollapsed && label && _jsx(Badge, {
        color: labelColor,
        "data-testid": "flowbite-sidebar-label",
        hidden: isCollapsed,
        className: theme.label,
        children: label
      })]
    }))
  });
});
SidebarItem.displayName = 'Sidebar.Item';